// Details Disclosure Web Component
// Handles accordion/disclosure UI patterns with focus management

class DetailsDisclosure extends HTMLElement {
  private mainDetailsToggle: HTMLDetailsElement

  constructor() {
    super()
    this.mainDetailsToggle = this.querySelector('details')!

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this))
  }

  private onFocusOut(): void {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close()
    })
  }

  close(): void {
    this.mainDetailsToggle.removeAttribute('open')
    this.mainDetailsToggle.querySelector('summary')!.setAttribute('aria-expanded', 'false')
  }
}

// Register custom element
if (!customElements.get('details-disclosure')) {
  customElements.define('details-disclosure', DetailsDisclosure)
}

export default DetailsDisclosure
